import moveOverlays from './helpers/moveOverlays';

/**
 * Tutorial scenarios defined step by step
 *
 * Hint for step configuration:
 * • {string} path - Current page's relative path
 * • {string} element - CSS selector for the element that we need to highlight
 * • {node} intro - Node with the text of this step
 * • {string} position - (optional) Relative position of tooltip to the element (see introJsPropTypes.tooltipPosition)
 * • {string} tooltipClass - (optional) Class applied to the tooltip
 * • {string} highlightClass - (optional) Class applied to the highlight
 * • {string} passTarget - CSS selector for the trigger element, which is an aim of current step
 * • {string} passEventType - Event type that we have to watch ('click' | 'change')
 * • {function} passCondition - Function of event.target that should return true if condition is fulfilled
 */

export const scenariosSteps = [
  [
    {
      path: '/chatbot',
      element: '.scenario1-step1',
      intro:
        '<small><strong>Step 1 of 12</strong></small><p>Enable chatbot integration to&nbsp;begin this tutorial</p>',
      passTarget: '[name=enabled_toggle]',
      passEventType: 'change',
      passCondition: (target) => target.checked,
    },
    {
      path: '/chatbot',
      element: '.scenario1-step2',
      intro:
        '<small><strong>Step 2 of 12</strong></small><p>Choose the <strong>Demo Chatbot</strong> option. It would let you play with one of our presets.</p>',
      passTarget: '[value=DEFAULT]',
      passEventType: 'change',
      passCondition: (target) => target.checked,
    },
    {
      path: '/chatbot',
      element: '.scenario1-step3',
      position: 'right',
      intro:
        '<small><strong>Step 3 of 12</strong></small><p>Select one of these predefined chatbots to play with</p>',
      passTarget: '[name=story_id]',
      passEventType: 'change',
      passCondition: (target) => target.value !== '',
    },
    {
      path: '/chatbot',
      element: '.scenario1-step4',
      intro:
        '<small><strong>Step 4 of 12</strong></small><p>Click <strong>Connect</strong> button to connect a chatbot globally</p>',
      passTarget: '.scenario1-step4 > button',
      passEventType: 'click',
      passCondition: () => true,
      onAfterChange: moveOverlays,
    },
    {
      path: '/chatbot',
      element: '.scenario1-step5',
      intro:
        '<small><strong>Step 5 of 12</strong></small><p>Great job! Now you have a chatbot set globally for all your existing and further channels. Now let‘s go to <strong>Channel Manager</strong> to create a new one.</p>',
      passTarget: '.scenario1-step5',
      passEventType: 'click',
      transitionDelay: 1000,
      passCondition: () => true,
      onAfterChange: () => moveOverlays('navbar-drawer-container'),
    },
    {
      path: '/channels',
      element: '.scenario1-step6',
      intro:
        '<small><strong>Step 6 of 12</strong></small><p>To change the chatbot for the specified channel, click the <strong>Edit</strong> button.</p>',
      passTarget: '.scenario1-step6',
      passEventType: 'click',
      passCondition: () => true,
      onAfterChange: moveOverlays,
    },
    {
      path: '/channels',
      element: '.scenario1-step7',
      intro:
        '<small><strong>Step 7 of 12</strong></small><p>Select the needed chatbot from the corresponding <strong>Chatbot</strong> dropdown.</p>',
      passTarget: '[name=chatbot_story_id]',
      passEventType: 'change',
      passCondition: () => true,
      onAfterChange: () => moveOverlays('channel-dialog'),
    },
    {
      path: '/channels',
      element: '.scenario1-step8',
      intro:
        '<small><strong>Step 8 of 12</strong></small><p>Click the <strong>Update channel</strong> button.</p>',
      passTarget: '.scenario1-step8',
      passEventType: 'click',
      passCondition: () => true,
    },
    {
      path: '/channels',
      element: '.scenario1-step9',
      intro:
        '<small><strong>Step 9 of 12</strong></small><p>You can also turn the chatbot on and off for a particular chat. Navigate to the <strong>Chats</strong> page</p>',
      passTarget: '.scenario1-step9',
      passEventType: 'click',
      transitionDelay: 500,
      passCondition: () => true,
      onAfterChange: () => moveOverlays('navbar-drawer-container'),
    },
    {
      path: '/chats',
      element: '.scenario1-step10',
      intro:
        '<small><strong>Step 10 of 12</strong></small><p>Click any chat of your choice. This one would work for our tutorial</p>',
      passTarget: '.scenario1-step10',
      passEventType: 'click',
      passCondition: () => true,
      onAfterChange: () => moveOverlays('conversation-list-container'),
    },
    {
      path: '/chats',
      element: '.scenario1-step11',
      intro:
        '<small><strong>Step 11 of 12</strong></small><p>Connect the Chatbot to this particular chat.<br><br>If chatbot is connected, chatbot start the conversation and ends it, when the scenario is finished or when the operator sends the first message to the customer. In any case, the chatbot will be automatically reconnected in 60 minutes or can be reconnected instantly by an operator.</p>',
      passTarget: '[name=checkedA]',
      passEventType: 'change',
      passCondition: () => true,
    },
    {
      path: '/chats',
      intro:
        '<small><strong>Step 12 of 12</strong></small><p>Great job! Now you know basics of chatbot configuration. Feel free to check everything by yourself.</p>',
    },
  ],
];
